import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AwsRum, AwsRumConfig } from 'aws-rum-web';

import { environment } from './environments/environment';

import { AppModule } from './app/app.module';

function initRum(): void {
  try {
    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      identityPoolId: environment.rum.identityPoolId,
      endpoint: `https://dataplane.rum.${environment.rum.region}.amazonaws.com`,
      telemetries: ['performance', 'errors', 'http'],
      allowCookies: true,
      enableXRay: false,
    };

    new AwsRum(environment.rum.applicationId, environment.version, environment.rum.region, config);
  } catch (error) {
    // RUM must never block or crash app bootstrap
    console.error('AWS RUM init failed', error);
  }
}

if (environment?.production) {
  enableProdMode();
}

initRum();

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => console.error(err));
